<!-- LoginAlertModal.vue (Bootstrap 5.3 적용판) -->
<template>
  <div
    ref="modalEl"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="loginAlertLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header">
          <slot name="header">
            <h5 id="loginAlertLabel" class="modal-title">
              로그인 후 이용 가능합니다.
            </h5>
            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              @click="close"
            ></button>
          </slot>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <slot name="body">
            <p class="mb-0">서비스 이용을 계속하려면 로그인해 주세요.</p>
          </slot>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <slot name="footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              @click="close"
            >
              닫기
            </button>
            <button type="button" class="btn btn-primary" @click="goLoginPopup">
              로그인 하러 가기
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * Bootstrap 5.3 Modal (opt-in)
 * - 번들 하나만 사용(bootstrap.bundle.min.js 또는 ESM 부분 임포트)
 * - window.bootstrap 미사용
 */
import {
  ref,
  onMounted,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";
import { Modal } from "bootstrap";
import { useModalStore } from "@/store/modalStore";
import { logError, logDebug } from "@/utils/logHelper";
import { useRouter } from "vue-router";

const emit = defineEmits(["close"]);
const modalStore = useModalStore();
const router = useRouter();

const modalEl = ref(null);
let modalInst = null;

onMounted(() => {
  modalInst = Modal.getOrCreateInstance(modalEl.value, {
    backdrop: true, // 필요 시 'static'으로 바꿔 외부 클릭 닫힘 방지
    keyboard: true,
    focus: true,
  });
  modalEl.value.addEventListener("hidden.bs.modal", () => emit("close"));
  modalInst.show();
});

onBeforeUnmount(() => {
  modalInst?.dispose();
});

function close() {
  modalInst?.hide();
}

function goLoginPopup(next) {
  try {
    logDebug("goLoginPopup triggered");

    // 현재 모달 닫고 -> 닫힌 뒤 login route로 이동
    modalEl.value.addEventListener(
      "hidden.bs.modal",
      () => {
        const nextPath =
          typeof next === "string"
            ? next
            : router.currentRoute.value.fullPath;

        router.push({ path: "/login", query: { next: nextPath } });
      },
      { once: true }
    );

    close();
  } catch (e) {
    logError("Error in goLoginPopup:", e);
    const { proxy } = getCurrentInstance();
    proxy?.$toast?.error("로그인 화면 이동 중 오류가 발생했습니다.");
  }
}
</script>

<!-- Bootstrap 유틸리티로 충분 — 별도 CSS 불필요 -->
<style scoped></style>
